import * as React from 'react';

import { Link } from '@cian/link-component';
import { trackingShowPopup, trackingGoBackToAd } from './tracking';

import * as style from './style.css';

export interface IBackToAdPopupState {
  open: boolean;
}

export interface IBackToAdPopupProps {
  onClick(): void;
  onClose(): void;
}

export class BackToAdPopup extends React.Component<IBackToAdPopupProps, IBackToAdPopupState> {
  public state = {
    open: true,
  };

  // eslint-disable-next-line react/no-deprecated
  public componentWillMount() {
    trackingShowPopup();
    document.addEventListener('click', this.closePopup);
  }

  public componentDidUpdate(prevProps: {}, prevState: IBackToAdPopupState) {
    if (prevState.open !== this.state.open && !this.state.open) {
      document.removeEventListener('click', this.closePopup);
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.closePopup);
    this.props.onClose();
  }

  private handleClick = () => {
    trackingGoBackToAd();
    this.closePopup();
    this.props.onClick();
  };

  private closePopup = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  public render() {
    return this.state.open ? (
      <div className={style['back-to-ad-popup']}>
        <div className={style['back-to-ad-popup_container']}>
          <p className={style['back-to-ad-popup_title']}>Ваше объявление почти готово!</p>
          <p className={style['back-to-ad-popup_text']}>
            Добавьте еще немного информации об объекте и опубликуйте объявление.
          </p>
          <Link onClick={this.handleClick} className={style['back-to-ad-popup_link']}>
            Вернуться к заполнению
          </Link>
        </div>
      </div>
    ) : null;
  }
}
